<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-if="showSkeletonTable == false"
      :tableTitle="'Roteiros'"
      :newRowmodalButtonText="'Adicionar Roteiro'"
      :tableHeader="headers"
      :tableRows="listaDeRoteiros"
      :isView="true"
      :isEdit="true"
      :isDel="true"
      :isFinish="false"
      :isPrint="false"
      :totalItens="total"
      v-on:datatable-newrow="adicionarNovoRoteiro"
      v-on:datatable-viewrow="visualizarRoteiro"
      v-on:datatable-updaterow="editarRoteiro"
      v-on:datatable-deleterow="excluirRoteiro"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable
      v-if="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <ModalCustomSize
      :modalSize="modalCustomSize.size"
      :modalClose="false"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="fecharModal"
      v-on:formmodal-action="acaoRoteiro"
    >
      <v-form id="comeco" v-model="estaValido">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>

          <v-tooltip v-if="!modalCustomSize.isView" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mt-7"
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="novoCnae()"
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Adicionar novo CNAE</span>
          </v-tooltip>

          <v-col cols="2">
            <v-autocomplete
              :readonly="modalCustomSize.isView"
              label="Cnaes"
              :items="listaDeCnes"
              autocomplete="off"
              v-model="cnaeSelecionado"
            />
          </v-col>

          <v-col>
            <v-text-field
              :readonly="modalCustomSize.isView"
              v-model="modalCustomSize.roteiros.nomeRoteiro"
              autocomplete="off"
              name="tituloRoteiro"
              label="Título do Roteiro"
              :rules="[rules.requerido]"
            ></v-text-field>
          </v-col>

          <v-tooltip v-if="!modalCustomSize.isView && modalCustomSize.roteiros.setores.length <= 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mt-7"
                icon
                color="green"
                v-bind="attrs"
                v-on="on"
                @click="novoSetor()"
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Adicionar Novo Setor</span>
          </v-tooltip>
        </v-row>

        <div v-if="modalCustomSize.roteiros.cnaes.length > 0">
          <v-list>
            <v-list-group no-action>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>Cnaes Vinculados</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item-content 
                v-for="(cnae, l) in modalCustomSize.roteiros.cnaes"
                :key="l"
              >
                <v-row class="mr-4">
                  <v-col cols="2">
                    <v-text-field
                      class="ml-4"
                      v-model="cnae.text"
                      autocomplete="off"
                      name="codigoCnae"
                      label="Código CNAE"
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                      v-model="cnae.nomeCnae"
                      autocomplete="off"
                      name="nomeCnae"
                      label="Nome CNAE"
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <v-text-field
                      v-model="cnae.descricaoCnae"
                      autocomplete="off"
                      name="descricaoCnae"
                      label="Descrição CNAE"
                      readonly
                    ></v-text-field>
                  </v-col>

                  <v-tooltip v-if="!modalCustomSize.isView" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-6"
                        icon
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="removerCnae(l)"
                      >
                        <v-icon>mdi-close-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Remover CNAE: {{ cnae.text }}</span>
                  </v-tooltip>
                </v-row>
              </v-list-item-content>

            </v-list-group>
          </v-list>
          
        </div>

        <div v-if="modalCustomSize.isEdit || modalCustomSize.isView">
          <v-list>
            <v-list-group
              v-for="(setor, i) in modalCustomSize.roteiros.setores"
              :key="i"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content @click="buscaQuestoes(setor, i)">
                  <v-list-item-title v-text="setor.nomeSetor"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item-content>
                <v-row cols="12" align="center">
                    <v-tooltip v-if="!modalCustomSize.isView" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-4"
                          icon
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="removerSetor(i)"
                        >
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover Setor {{ i + 1 }}</span>
                    </v-tooltip>

                  <v-col>
                    <v-text-field
                      :readonly="modalCustomSize.isView"
                      v-model="setor.nomeSetor"
                      autocomplete="off"
                      name="nomeSetor"
                      class="mr-4"
                      label="Setor"
                      :rules="[rules.requerido]"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-content>

              <div v-if="!setor.questoes.length > 0">
                <v-dialog v-model="dialog" persistent width="1200">
                  <v-card color="#3c8dbc" dark>
                    <v-card-title>
                      <v-row justify="center">
                        <v-col class="text-h5 text-bold" cols="auto">
                          Por favor aguarde um momento...
                        </v-col>
                      </v-row>

                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                      ></v-progress-linear>
                    </v-card-title>
                  </v-card>
                </v-dialog>
              </div>

              <div v-else>
                <v-list-item v-for="(questao, j) in setor.questoes" :key="j" >
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12">
                        <v-subheader> Questão {{ j + 1 }} </v-subheader>
                        <v-divider />
                      </v-col>
                      <v-tooltip v-if="!modalCustomSize.isView" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mt-7 ml-4"
                            icon
                            color="red"
                            v-bind="attrs"
                            v-on="on"
                            @click="removerQuestao(i, j)"
                          >
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover Questão {{ j + 1 }}</span>
                      </v-tooltip>

                      <v-col>
                        <v-textarea
                          :readonly="modalCustomSize.isView"
                          v-model="questao.nomeQuestao"
                          autocomplete="off"
                          name="nomeQuestao"
                          label="Questão"
                          rows="4"
                          row-height="30"
                          :rules="[rules.requerido]"
                        ></v-textarea>
                        <v-text-field
                          :readonly="modalCustomSize.isView"
                          v-model="questao.descricaoQuestao"
                          autocomplete="off"
                          name="descricaoQuestao"
                          label="Lei"
                        ></v-text-field>
                      </v-col>

                      <v-col v-if="questao.alternativas.length > 0" cols="5">
                        <v-row
                          cols="12"
                          v-for="(alternativa, k) in questao.alternativas"
                          :key="k"
                        >
                          <v-tooltip v-if="!modalCustomSize.isView" bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="red"
                                v-bind="attrs"
                                v-on="on"
                                @click="removerAlternativa(i, j, k)"
                              >
                                <v-icon>mdi-close-circle</v-icon>
                              </v-btn>
                            </template>
                            <span>Remover Alternativa {{ k + 1 }}</span>
                          </v-tooltip>

                          <v-col>
                            <v-text-field
                              :readonly="modalCustomSize.isView"
                              v-model="alternativa.nomeAlternativa"
                              autocomplete="off"
                              name="nomeAlternativa"
                              label="Alternativa"
                              :rules="[rules.requerido]"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="4">
                            <v-autocomplete
                              :readonly="modalCustomSize.isView"
                              label="Tipo Alternativa"
                              :items="listaDeTipoDeAlternativa"
                              v-model="alternativa.tipoAlternativa"
                              autocomplete="off"
                              :rules="[rules.requerido]"
                            />
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-tooltip v-if="!modalCustomSize.isView" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="mt-7 mr-4"
                            icon
                            color="green"
                            v-bind="attrs"
                            v-on="on"
                            @click="novaAlternativa(i, j)"
                          >
                            <v-icon>mdi-plus-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar nova Alternativa</span>
                      </v-tooltip>
                    </v-row>

                    <v-row>
                      <v-col v-if="!modalCustomSize.isView" cols="12" class="ma-2">
                        <v-row>
                          <div class="pa-2">
                            <v-btn @click="novoSetor()">Novo Setor</v-btn>
                          </div>

                          <div class="pa-2">
                            <v-btn @click="novaQuestao(i)">Nova Questão</v-btn>
                          </div>

                          <div class="pa-2">
                            <v-btn @click="novaQuestaoPadrão(i)">Nova Questão Padrão</v-btn>
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                    <br />

                  </v-list-item-content>
                </v-list-item>
              </div>

            </v-list-group>
          </v-list>
        </div>

        <div v-else>
          <v-row
            cols="12"
            align="center"
            v-for="(setor, i) in modalCustomSize.roteiros.setores"
            :key="i"
          >
            <br />
            <v-col cols="12"><v-divider /></v-col>
            <br />

            <v-tooltip v-if="!modalCustomSize.isView" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                  @click="removerSetor(i)"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </template>
              <span>Remover Setor {{ i + 1 }}</span>
            </v-tooltip>

            <v-col>
              <v-text-field
                :readonly="modalCustomSize.isView"
                v-model="setor.nomeSetor"
                name="nomeSetor"
                label="Setor"
                autocomplete="off"
                :rules="[rules.requerido]"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-row cols="12" v-for="(questao, j) in setor.questoes" :key="j">
                <v-col cols="12">
                  <v-subheader> Questão {{ j + 1 }} </v-subheader>
                  <v-divider />
                </v-col>
                <v-tooltip v-if="!modalCustomSize.isView" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mt-7"
                      icon
                      color="red"
                      v-bind="attrs"
                      v-on="on"
                      @click="removerQuestao(i, j)"
                    >
                      <v-icon>mdi-close-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover Questão {{ j + 1 }}</span>
                </v-tooltip>

                <v-col>
                  <v-textarea
                    :readonly="modalCustomSize.isView"
                    v-model="questao.nomeQuestao"
                    name="nomeQuestao"
                    label="Questão"
                    rows="4"
                    row-height="30"
                    autocomplete="off"
                    :rules="[rules.requerido]"
                  ></v-textarea>
                  <v-text-field
                    :readonly="modalCustomSize.isView"
                    v-model="questao.descricaoQuestao"
                    autocomplete="off"
                    name="descricaoQuestao"
                    label="Lei"
                  ></v-text-field>
                </v-col>

                <v-col v-if="questao.alternativas.length > 0" cols="5">
                  <v-row
                    cols="12"
                    align="center"
                    v-for="(alternativa, k) in questao.alternativas"
                    :key="k"
                  >
                    <v-tooltip v-if="!modalCustomSize.isView" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="removerAlternativa(i, j, k)"
                        >
                          <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover Alternativa {{ k + 1 }}</span>
                    </v-tooltip>

                    <v-col>
                      <v-text-field
                        :readonly="modalCustomSize.isView"
                        v-model="alternativa.nomeAlternativa"
                        autocomplete="off"
                        name="nomeAlternativa"
                        label="Alternativa"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-autocomplete
                        :readonly="modalCustomSize.isView"
                        label="Tipo Alternativa"
                        :items="listaDeTipoDeAlternativa"
                        v-model="alternativa.tipoAlternativa"
                        autocomplete="off"
                        :rules="[rules.requerido]"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-tooltip v-if="!modalCustomSize.isView" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mt-7"
                      icon
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      @click="novaAlternativa(i, j)"
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar nova Alternativa</span>
                </v-tooltip>
              </v-row>
            </v-col>

            <v-col v-if="!modalCustomSize.isView" cols="12" class="ma-2">
              <v-row>
                <div class="pa-2">
                  <v-btn @click="novoSetor()">Novo Setor</v-btn>
                </div>

                <div class="pa-2">
                  <v-btn @click="novaQuestao(i)">Nova Questão</v-btn>
                </div>

                <div class="pa-2">
                  <v-btn @click="novaQuestaoPadrão(i)">Nova Questão Padrão</v-btn>
                </div>
              </v-row>
            </v-col>
            <br />
          </v-row>
        </div>        
      </v-form>
    </ModalCustomSize>
  </v-col>
</template>

<script>
import DataTable from "@/components/DataTable2.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import SkeletonTable from "../components/SkeletonTable";
import store from "@/store/index";
import axios from "../plugins/axios";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    ModalCustomSize,
    SkeletonTable,
    Alertas,
    AlertasModal
  },

  data: () => ({
    //Paginação 
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    showSkeletonTable: true,
    estaValido: false,
    dialog: false,

    headers: [
      {
        text: "ID",
        value: "numeroRoteiro",
      },
      {
        text: "Roteiro",
        value: "nomeRoteiro",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],

    modalCustomSize: {
      size: "1600",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isView: false,
      isLoadingRequestDisable: false,
      isButtonsVisible: false,
      isButtonsDisabled: false,
      roteiros: {
        numeroRoteiro: null,
        nomeRoteiro: null,
        descricaoRoteiro: null,
        cnaes: [],
        setores: [],
        setoresRemovidos: [],
        questoesRemovidas: [],
        alternativasRemovidas: []
      },
    },

    cnaeSelecionado: null,
    listaDeCnes: [],
    listaDeRoteiros: [],

    listaDeTipoDeAlternativa: [
      {
        text: "RADIO",
        value: 0,
      },
      {
        text: "CHECKBOX",
        value: 1,
      },
      {
        text: "TEXTBOX",
        value: 2,
      },
    ],

    rules: {
      requerido: (value) => value != null || "Requer o campo!",
    },

  }),

  created() {
    this.inicializar();
  },

  watch: {
    estaValido() {
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
    }
  },

  methods: {
    async inicializar() {
      this.showSkeletonTable = true;
      try {
        this.buscaTodosRoteiros()
        this.buscaTodosCnaes()
      } catch (error) {
        console.log(error.response);
      }
    },

    async buscaTodosRoteiros() {
      try {
        const responseRoteiro = await axios.put("listaroteiros", {page: this.page, search: this.search}, this.config)
        if(!responseRoteiro.data || responseRoteiro.data.length > 0) {
          this.listaDeRoteiros = responseRoteiro.data
          this.total = responseRoteiro.data[0].total
        }
        
        this.showSkeletonTable = false;
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      }
    },

    async updateSearch(search) {
      if(search){
        this.search = search
        this.page = 1
        await this.buscaTodosRoteiros()
      } else {
        this.page = 1
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page
      await this.buscaTodosRoteiros()
    },

    async buscaTodosCnaes() {
      try {
        const responseCnaes = await axios.get("cnae", this.config);

        this.listaDeCnes = responseCnaes.data.map(function(cnaeSelecionado) {
          return {
            text: cnaeSelecionado.codigoCnae,
            value: cnaeSelecionado.numeroCnae,
            nomeCnae: cnaeSelecionado.nomeCnae,
            descricaoCnae: cnaeSelecionado.descricaoCnae
          };
        });

      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      }
    },

    async buscaQuestoes(setorSelecionado, index) {
      try {
        if(!this.modalCustomSize.roteiros.setores[index].questoes.length > 0) {
          this.dialog = true
          const responseQuestoes = await axios.put("roteiroQuestoes", setorSelecionado, this.config)
          this.modalCustomSize.roteiros.setores[index].questoes = responseQuestoes.data.questoes
          this.dialog = false
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      }
    },

    novoCnae() {
      if (this.cnaeSelecionado != null) {
        const vincularCnae = this.listaDeCnes.filter(
          (cnae) => cnae.value == this.cnaeSelecionado
        );

        this.modalCustomSize.roteiros.cnaes.push(vincularCnae[0]);
        this.cnaeSelecionado = null;
      }
    },

    novoSetor() {
      this.modalCustomSize.roteiros.setores.push({
        numeroSetor: null,
        nomeSetor: null,
        questoes: [],
      });
    },

    novaQuestao(indiceSetor) {
      this.modalCustomSize.roteiros.setores[indiceSetor].questoes.push({
        numeroQuestao: null,
        nomeQuestao: null,
        descricaoQuestao: null,
        alternativas: [],
      });
    },

    novaQuestaoPadrão(indiceSetor) {
      this.modalCustomSize.roteiros.setores[indiceSetor].questoes.push({
        numeroQuestao: null,
        nomeQuestao: null,
        descricaoQuestao: null,
        alternativas: [
          {
            numeroAlternativa: null,
            nomeAlternativa: "SIM",
            tipoAlternativa: 0,
          },
          {
            numeroAlternativa: null,
            nomeAlternativa: "NÃO",
            tipoAlternativa: 0,
          },
          {
            numeroAlternativa: null,
            nomeAlternativa: "NA",
            tipoAlternativa: 0,
          },
          {
            numeroAlternativa: null,
            nomeAlternativa: "NO",
            tipoAlternativa: 0,
          },
        ],
      });
    },

    novaAlternativa(indiceSetor, indiceQuestao) {
      this.modalCustomSize.roteiros.setores[indiceSetor].questoes[indiceQuestao].alternativas.push({
        numeroAlternativa: null,
        nomeAlternativa: null,
        tipoAlternativa: null,
      });
    },

    removerCnae(indiceCnae) {
      if(confirm("Você realmente deseja remover o CNAE desse Roteiro?")) {
        this.modalCustomSize.roteiros.cnaes.splice(indiceCnae, 1)
      }
    },

    removerSetor(indiceSetor) {
      if(confirm("Você realmente deseja remover esse Setor? (A exclusão desse Setor acarretara à exclusão de respostas desse Setor)")) {
        this.modalCustomSize.roteiros.setoresRemovidos.push(this.modalCustomSize.roteiros.setores.splice(indiceSetor, 1))
      }
    },

    removerQuestao(indiceSetor, indiceQuestao) {
      if(confirm("Você realmente deseja remover essa Questão? (A exclusão dessa Questão poderá acarretar à exclusão de respostas relacionada a ela)")) {
        this.modalCustomSize.roteiros.questoesRemovidas.push(this.modalCustomSize.roteiros.setores[indiceSetor].questoes.splice(indiceQuestao, 1))
      }
    },

    removerAlternativa(indiceSetor, indiceQuestao, indiceAlternativa) {
      if(confirm("Você realmente deseja remover essa Alternativa? (A exclusão dessa Alternativa poderá acarretar à exclusão de respostas referentes a essa Alternativa)")) {
        this.modalCustomSize.roteiros.alternativasRemovidas.push(this.modalCustomSize.roteiros.setores[indiceSetor].questoes[indiceQuestao].alternativas.splice(indiceAlternativa, 1))
      }
    },

    async acaoRoteiro() {
      try {
        if(this.modalCustomSize.roteiros.cnaes.length > 0) {
          if (this.modalCustomSize.isEdit == false) {
            this.insereRoteiro(this.modalCustomSize.roteiros);
          } else {
            this.editaRoteiro(this.modalCustomSize.roteiros);
          }
        } else {
          this.alertaModal.texto = "Erro, insira um CNAE antes de continuar!";
          this.alertaModal.tipo = 'erro';
        }
      } catch (error) {
        console.log(error.response);
      }
    },

    async insereRoteiro(roteiro) {
      try {
        this.alertaModal.tipo = null;
        await axios.post("roteiro", roteiro, this.config)
        this.$socket.emit("insertLog");
        this.modalCustomSize.isOpen = false
        this.alerta.texto = "Roteiro adicionado com sucesso!"
        this.alerta.tipo = 'sucesso';
        
      } catch (error) {
        this.alertaModal.texto = error.response.data.message
        this.alertaModal.tipo = 'erro';
      } finally {
        this.inicializar();
      }
    },

    async editaRoteiro(roteiro) {
      try {
        roteiro['edicao'] = true       
        if(confirm("Você realmente deseja atualizar este Roteiro? (Todas as Tarefas referentes a esse Roteiro serão atualizadas)")){
          this.alertaModal.tipo = null;
          await axios.put("roteiro", roteiro, this.config)
          this.$socket.emit("insertLog");
          this.modalCustomSize.isOpen = false
        }

        this.alerta.texto = "Roteiro atualizado com sucesso!"
        this.alerta.tipo = 'sucesso';
        
      } catch (error) {
        this.alertaModal.texto = error.response.data.message
        this.alertaModal.tipo = 'erro';
      } finally {
        this.inicializar();
      }
    },

    async excluirRoteiro(roteiroSelecionado) {
      try {
        if(confirm("Você realmente deseja excluir este Roteiro? (Todas as Tarefas referentes a esse Roteiro serão apagadas)")){
          this.erro = false;
          await axios.delete("roteiro", {
            data: roteiroSelecionado,
            headers: this.config.headers,
          });
          this.$socket.emit("insertLog");
        }

        this.alerta.texto = "Roteiro removido"
        this.alerta.tipo = 'sucesso';
        
      } catch (error) {
        console.log(error.response)
        this.alerta.texto = error.response.data.message
        this.alerta.tipo = 'erro';
      } finally {
        this.inicializar();
      }
    },

    adicionarNovoRoteiro() {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isView = false;
      this.modalCustomSize.isButtonsVisible = true;
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
      this.modalCustomSize.buttonText = "Adicionar";
      this.modalCustomSize.formTitle = "Adicionar Novo Roteiro";

      this.cnaeSelecionado = null;
      this.modalCustomSize.roteiros.nomeRoteiro = null,
      this.modalCustomSize.roteiros.setores = [];
      this.modalCustomSize.roteiros.cnaes = [];
      this.modalCustomSize.roteiros.setoresRemovidos = [];
      this.modalCustomSize.roteiros.questoesRemovidas = [];
      this.modalCustomSize.roteiros.alternativasRemovidas = [];
    },

    editarRoteiro(roteiro) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.isView = false;
      this.modalCustomSize.isButtonsVisible = true;
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
      this.modalCustomSize.buttonText = "Editar";
      this.modalCustomSize.formTitle = "Editar Roteiro";

      this.modalCustomSize.roteiros.numeroRoteiro = roteiro.numeroRoteiro,
      this.modalCustomSize.roteiros.nomeRoteiro = roteiro.nomeRoteiro,
      this.modalCustomSize.roteiros.cnaes = roteiro.cnaes;
      this.modalCustomSize.roteiros.setores = roteiro.setores;
      this.modalCustomSize.roteiros.setoresRemovidos = [];
      this.modalCustomSize.roteiros.questoesRemovidas = [];
      this.modalCustomSize.roteiros.alternativasRemovidas = [];
    },

    visualizarRoteiro(roteiro) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.isView = true;
      this.modalCustomSize.isButtonsVisible = false;
      this.modalCustomSize.formTitle = "Visualizar Roteiro";

      this.modalCustomSize.roteiros.numeroRoteiro = roteiro.numeroRoteiro,
      this.modalCustomSize.roteiros.nomeRoteiro = roteiro.nomeRoteiro,
      this.modalCustomSize.roteiros.cnaes = roteiro.cnaes;
      this.modalCustomSize.roteiros.setores = roteiro.setores;
      this.modalCustomSize.roteiros.setoresRemovidos = [];
      this.modalCustomSize.roteiros.questoesRemovidas = [];
      this.modalCustomSize.roteiros.alternativasRemovidas = [];
    },

    fecharModal() {
      this.modalCustomSize.isOpen = false;

      this.cnaeSelecionado = null;
      this.modalCustomSize.roteiros.numeroRoteiro = null,
      this.modalCustomSize.roteiros.nomeRoteiro = null;
      this.modalCustomSize.roteiros.cnaes = [];
      this.modalCustomSize.roteiros.setores = [];
      this.modalCustomSize.roteiros.setoresRemovidos = [];
      this.modalCustomSize.roteiros.questoesRemovidas = [];
      this.modalCustomSize.roteiros.alternativasRemovidas = [];
    },
  },
};
</script>
